// src/services/authService.ts

import { MsalPlugin } from 'capacitor-msal-auth';
import { APP_NAME, CLIENT_CODE, MSAL_ACC, RHYBUS_ACCESS_TOKEN } from '../../Configuration';
import { loadConfig } from '../../authConfig';
import { Capacitor } from '@capacitor/core';

let isMsalInitialized = false;

const ensureMsalInitialized = async () => {
  const { msalPWAConfig } = await loadConfig();
  if (!isMsalInitialized) {
    try {
     await MsalPlugin.initializePcaInstance(msalPWAConfig);
      isMsalInitialized = true;
    } catch (err) {
      console.error('MSAL Init Failed:', err);
      throw err;
    }
  }
};

export const msalMobileLogin = async () => {
  await ensureMsalInitialized();

  try {
    const result = await MsalPlugin.login();
    const accessToken = result.accessToken;

    if (accessToken) {
      localStorage.setItem(RHYBUS_ACCESS_TOKEN, '')
      localStorage.setItem(RHYBUS_ACCESS_TOKEN, accessToken);
      localStorage.setItem(MSAL_ACC, result.account.homeAccountId);
      localStorage.setItem(CLIENT_CODE, APP_NAME);
      return result
    }else{
    return await msalMobileLogin();
    }
  } catch (error) {
    console.error('MSAL Login Failed:', error);
    await msalMobileLogin();
    throw error;
  }
};

export const msalMobileSilentlyToken = async () => {
  await ensureMsalInitialized();

  try {
    const username = localStorage.getItem(MSAL_ACC);
    if (!username) {
      console.warn(' No account stored. Performing login...');
      return await msalMobileLogin();
    }

    const result = await MsalPlugin.login({ identifier: username });
    const accessToken = result.accessToken;

    if (accessToken) {
      localStorage.setItem(RHYBUS_ACCESS_TOKEN, '')
      localStorage.setItem(RHYBUS_ACCESS_TOKEN, accessToken);
      localStorage.setItem(MSAL_ACC, result.account.homeAccountId);
      localStorage.setItem(CLIENT_CODE, APP_NAME);
    }

    return result;
  } catch (e) {
    console.warn('Silent login failed. Falling back to interactive login...');
    return await msalMobileLogin();
  }
};

export const getAccessToken = () => localStorage.getItem(RHYBUS_ACCESS_TOKEN);

export const msalMobileLogout = async()=>{
const platform = Capacitor.getPlatform();
await ensureMsalInitialized();
if(platform === 'ios'){
localStorage.setItem(RHYBUS_ACCESS_TOKEN, '')
localStorage.setItem(RHYBUS_ACCESS_TOKEN, '');
localStorage.setItem(MSAL_ACC, '');
localStorage.setItem(CLIENT_CODE,'');
window.location.reload(); 
await MsalPlugin.logout()
}else{
localStorage.setItem(RHYBUS_ACCESS_TOKEN, '')
localStorage.setItem(RHYBUS_ACCESS_TOKEN, '');
localStorage.setItem(MSAL_ACC, '');
localStorage.setItem(CLIENT_CODE,'');
window.location.reload();
}
}